import utils from "@/utils";

export default {

    computed: {
        utils(){
            return utils;
        }
    }

}
